import { useState } from "react";
import testData from "../utilities/testData";
import {
  addOneDoc,
  readAllDocs,
  getSomeDocs,
  modifyOneDoc,
  deleteOneDoc,
} from "../utilities/firebase";

export default function Main({
  tasks,
  filterCat,
  renderTasks,
  setEditTaskId,
  showModal,
  setShowModal,
}) {
  const [category, setCategory] = useState("inbox");

  function handleCompleteTask(e) {
    let docId = e.currentTarget.dataset.id;
    modifyOneDoc(docId, { category: "completed" });
    renderTasks();

    // This is like edit task shortcut.
    //find task from task id

    //filter task from task array

    //modify category to complete - can do it directly in firebase

    //add to new array - not required if updating in firebase.
    //update in firebase
    //rerender from state or read from firebase again
  }

  function handleEditTask(e) {
    console.log("editTask");
    setShowModal(true);
    let docId = e.currentTarget.dataset.id;
    setEditTaskId(docId);

    //find task from task id
    let foundTask = tasks.filter((item) => item.id === docId);
    console.log(foundTask);
    //filter task from task array
    //render it in form. The Save button should keep the same id and overwrite the doc.
    //add to new array
    //update in firebase
    //rerender from state or read from firebase again
  }

  function handleDeleteTask(e) {
    console.log("delete task");
    let docId = e.currentTarget.dataset.id;
    modifyOneDoc(docId, { category: "deleted" });
    renderTasks();
    //find task from task id
    //filter task from task array
    //modify category to complete
    //add to new array
    //update in firebase
    //rerender from state or read from firebase again
  }

  function handleMoveTask() {
    console.log("Move Task");
    //find task from task id
    //filter task from task array
    //modify category to complete
    //add to new array
    //update in firebase
    //rerender from state or read from firebase again
  }

  function handleScheduleTask() {
    console.log("schedule Task");
    //find task from task id
    //filter task from task array
    //modify category to complete
    //add to new array
    //update in firebase
    //rerender from state or read from firebase again
  }

  const taskArray = tasks;
  const renderArray = taskArray.filter((item) => item.category === filterCat);

  // console.log("main", tasks)
  return (
    <main className="main">
      <button className="add-new-task-btn" onClick={(e) => setShowModal(true)}>
        Add new task
      </button>

      {renderArray.map((item) => {
        return (
          <div className="task-container">
            <div className="button-group">
              <button
                className="action-btn"
                data-id={item.id}
                onClick={handleCompleteTask}
              >
                <img src="/icons/complete.png" />
              </button>

              <button
                className="action-btn"
                data-id={item.id}
                onClick={handleEditTask}
              >
                <img src="/icons/edit.png" />
              </button>

              <button
                className="action-btn"
                data-id={item.id}
                onClick={handleDeleteTask}
              >
                <img src="/icons/delete.png" />
              </button>

              <button
                className="action-btn"
                data-id={item.id}
                onClick={handleEditTask}
              >
                <img src="/icons/move.png" />
              </button>

              <button
                className="action-btn"
                title="schedule"
                aria-label="schedule"
                data-id={item.id}
                onClick={handleEditTask}
              >
                <img src="/icons/schedule.png" />
              </button>
            </div>
            <p className="task">{item?.task}</p>
          </div>
        );
      })}
    </main>
  );
}

{
  /* 

   <svg
                viewBox="0 0 576 512"
                width="15"
                height="15"
                fill="#757575"
                title="edit"
              >
                <path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" />
              </svg>


   <svg
                viewBox="0 0 448 512"
                width="15"
                height="15"
                fill="#757575"
                title="trash-alt"
              >
                <path d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" />
              </svg>{" "}
  
  <svg
                viewBox="0 0 512 512"
                width="15"
                height="15"
                fill="#757575"
                title="th-list"
              >
                <path d="M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z" />
              </svg>
  
  <svg
  viewBox="0 0 448 512"
  width="15"
  height="15"
  fill="#757575"
  title="check-square"
>
  <path d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z" />
</svg>; 

<svg
                viewBox="0 0 448 512"
                width="15"
                height="15"
                title="calendar-alt"
                fill="#757575"
              >
                <path d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z" />
              </svg>




*/
}
